import React from "react";
import "./asiakaspalvelu.m.css";
const AsiakasPalvelu = () => {
  return (
    <div styleName="container">
      <div styleName="hero-image">
        <img src="https://s3-alpha-sig.figma.com/img/1c4c/1c56/077c2920d9ec8655d049089c2dfacbc7?Expires=1743984000&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=dG6Kpz7yVoaNo4Xqy0f~Zu-YtharChBXABuKbes3TgZwcP~mkvxCeaaex5IesfogwariSqGsTKGdpeHwW2nBJmzm0ZHLRjtTsEKkKUq7vcu69Nxva9~fXL1EZ68PXfl0j332mspOqULI57~zbGXa-~kmf40fq631-v3SLbq4BoUbLj5zjXadGFp0G-fA5c2XMg2Dn0obIbafLT0hqVUWtKST3QEGdbogMiF-f0APZbKDEJYuOC2vURfNCxkwy4hRvYN-FQYW52uCc4BHlpFCQ~LoroQkHZaGXqnhHb~wTf6W3j7cfNWpj01HCtMTLKPZCKpn3R71mq9NTsigVulloA__" />
        <h1 styleName="header-one">Yhteystiedot</h1>
      </div>
      <div styleName="flexwrapers">
        <div>
          <h2 styleName="header-two">Asiakaspalvelu ja yhteydenpito</h2>
          <div styleName="contact-top">
            <div>
              <h2 styleName="header-two-subhead">
                {" "}
                <i class="ri-phone-line"></i> Puhelinnumerot
              </h2>
            </div>
            <div>
              <p>
                Asiakaspalvelu: (ma-pe klo 9-12.30): <a href="tel:0444777888">044 477 7888</a>
              </p>
              <p>
                Studio/lähetys: 044 477 7800: <a href="tel:0444777800">044 477 7800</a>
              </p>
              <p>
                Rukouspuhelin: 040 172 7000: <a href="tel:040 172 7000">040 172 7000</a>
              </p>
              <p>
                WhatsApp studioon: <a href="https://wa.me/0444477447">044 447 7447</a>
              </p>
            </div>
          </div>
        </div>
        <div styleName="kiireliset-block">
          <div styleName="kiireliset-header">
            <h2 styleName="kiireliset-contents">
              <i class="ri-lightbulb-line"></i> Kiireiset toimitukselliset asiat, lähetä tekstiviesti:
            </h2>
            <p>Kirsi Rostamo (päätoimittaja): 040 547 133</p>
          </div>
        </div>

        <div>
          <h2 styleName="header-two"></h2>
          <div styleName="contact-top">
            <div>
              <h2 styleName="header-two-subhead">
                {" "}
                <i class="ri-phone-line"></i> Sähköpostiosoitteet
              </h2>
            </div>
            <div>
              <p styleName="emails-para">
                Asiakaspalvelu: <a href="mailto:asiakaspalvelu@radiodei.fi">asiakaspalvelu@radiodei.fi</a>
              </p>
              <p styleName="emails-para">
                Toimitus: <a href="mailto:toimitus@radiodei.fi">toimitus@radiodei.fi</a>
              </p>
              <p styleName="emails-para">
                Henkilökohtaiset: <a href="mailto:etunimi.sukunimi@radiodei.fi">etunimi.sukunimi@radiodei.fi</a>
              </p>
              <p styleName="emails-para">
                Kirsi Rostamo: <a href="mailto:etunimi.sukunimi@dei.fi">etunimi.sukunimi@dei.fi</a>
              </p>
            </div>
          </div>
        </div>

        <div styleName="flex-container">
          <div styleName="emails-top">
            <div styleName="emails-wrapper">
              <h2 styleName="header-two">Myynti ja mainonta</h2>
              <p styleName="emails-para">
                Sähköpostit muotoa: <a href="mailto:etunimi.sukunimi@radiodei.fi">etunimi.sukunimi@radiodei.fi</a>
              </p>

              <div styleName="contact-top">
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <div>
                    <h2 styleName="header-two-subhead">
                      {" "}
                      <i class="ri-arrow-right-circle-line"></i> Ohjelmamyynti ja nykyiset mainosasiakkaat
                    </h2>
                  </div>
                </div>
                <div>
                  <p>
                    Lauri Nurminen <br />
                    Varatoimitusjohtaja, myyntijohtaja <br />
                    040 731 9321
                  </p>
                  <p>
                    Pekka Vaismaa <br />
                    Myyntipäällikkö <br />
                    0500 662 340
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div styleName="contact-top contact-lower">
            <div>
              <h2 styleName="header-two-subhead">
                {" "}
                <i class="ri-arrow-right-circle-line"> </i>Mainosmyynti
              </h2>
            </div>
            <div styleName="contact-lower-para">
              <p>
                Juha Arko <br />
                Myyntipäällikkö <br />
                040 770 1540
              </p>
              <p>
                Ari Kuittinen <br />
                Myyntipäällikkö
                <br />
                050 525 6212
                <br />
              </p>
              <p>
                Seppo Laitila <br />
                Myyntipäällikkö
                <br />
                0400 954 747
                <br />
              </p>
              <p>
                Päivi Saloranta
                <br />
                Aluevastaava Pohjanmaa, Vaasa
                <br />
                040 777 7904
              </p>
            </div>
          </div>
        </div>
        <div styleName="left-top">
          <div styleName="contact-top">
            <h2 styleName="header-two-subhead">
              <i class="ri-arrow-right-circle-line"></i> Mainostuotanto
            </h2>
          </div>
          <p>
            Aleksi Paasonen
            <br />
            Äänituottaja/mainostuottaja <br />
          </p>
          <p>
            Antti Suonio <br />
            Äänituottaja/mainostuottaja
          </p>
        </div>
      </div>

      <div styleName="kayntiosoite">
        <div>
          <h2 styleName="header-two">Käyntiosoite ja kulkuyhteydet</h2>
          <div styleName="contact-top">
            <div>
              <h2 styleName="header-two-subhead">
                {" "}
                <i class="ri-map-pin-5-line"></i> Käyntiosoite
              </h2>
            </div>
            <div>
              <p>Mannerheimintie 105 00280 HELSINKI</p>
              <p>Sisäänkäynti: Mannerheimintie 105 ja Nauvontie 6 </p>
              <p>Ulko-ovet auki arkisin klo 7.45 – 15.45</p>
              <p>Muina aikoina sovi tulosta henkilökunnan kanssa</p>
            </div>
          </div>
        </div>
        <div styleName="reittikarta">
          <img src="https://s3-alpha-sig.figma.com/img/5898/4f2b/a853b2bd27b9aef91e9cf986963c6771?Expires=1743984000&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=ZLADESq6mLB8kRCLmHDl5Spus9JfJkWTQ9HIZPQplhQSQ1E1cKeFdDBx9R7pgSW5Js6etO2Ab3ILqtDyxLoyiCx0wscxO4t8hFMPoHEJozqzZBQKCYjbyPAcND6QhKiPQ7~s0CzDLiR97GOus6ykUhzQ4xdAltURwoEeRVCgQpSFKBHHZE~VeeR88op~0FIc09BvY5K-ineEkumXgjJXvmyc4ONgCLGUKhl9wxU2Z5TPy5LMWCVabotQAWjfICFJoS1lzl2wHQFBqLJxIeXnU2WXzsdCpfDK7h-8sLk0JGFgRTVmE3zgjFnqeJsawQC69CfPADeeduaePhvR6Zr4ew__" />
          <button>Reittiohjeet</button>
        </div>
      </div>

      <div styleName="contact-top">
        <div>
          <h2 styleName="header-two-subhead">
            {" "}
            <i class="ri-bus-2-fill"></i> Julkinen liikenne
          </h2>
        </div>
        <div styleName="list-styles">
          <p>Pasilan juna-asemalta:</p>
          <ul>
            <li>Bussi 506 (Ruskeasuon pysäkki)</li>
            <li>Bussi 59 (Ruskeasuon pysäkki)</li>
          </ul>
        </div>

        <div styleName="list-styles">
          <p>Helsingin keskustasta:</p>
          <ul>
            <li>Bussit: 40, 200, 300, 345, 400 (Elielinaukiolta)</li>
            <li>Raitiovaunu 10 (Ruskeasuon pysäkki)</li>
          </ul>
        </div>
      </div>

      <div>
        <div styleName="contact-top">
          <div>
            <h2 styleName="header-two-subhead">
              {" "}
              <i class="ri-bus-2-fill"></i> Pysäköinti
            </h2>
          </div>
          <div styleName="list-styles-lower">
            <div styleName="list-styles-lower-paras">
              <p>Vieraspaikat parkkihallissa.</p>
              <p>
                Käynti toimistoaikana klo 7.45-15.45. Muina kellonaikoina sovi sisäänkäynti Radio Dein henkilökunnan
                kanssa.
              </p>
            </div>
            <ul>
              <li>Parkkihalliin pääsee Nauvontietä pohjoisesta, (Hesburger-pääty) tai etelästä (Teboli-pääty).</li>
              <li>
                Sisäänkäynti parkkihalliin Nauvontie 6 kohdalta, ovien ollessa kiinni, paina Info-summeria, niin
                sisääntulo avataan.
              </li>
              <li>
                Aja luiskaa alas K1 kerrokseen ja käänny oikealle. Aja vielä yksi taso alas (myös K1 kerros). Kerroksen
                alussa on oikealla viisi (5) vieraspaikkaa.
              </li>
              <li>
                Mene hissillä 1. kerrokseen ja ilmoita aulalle rekisterinumerosi. Jatka sitten hissillä matkaa Radio
                Deihin kerrokseen 5.
              </li>
            </ul>
            <div styleName="list-lower-paras">
              <p>Vaihtoehtoisesti: läheisillä kaduilla 2-24 tunnin maksuttomia paikkoja</p>
            </div>
          </div>
          <div styleName="lower-two-images">
            <img src="https://s3-alpha-sig.figma.com/img/7c2e/5b8a/1df34ae729cb48998d065e41dc46dd01?Expires=1743984000&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=XtjPbNGIwPGFI412~iX3Oep5Py~HIjsWbORpg9SAivfzaOSxpylqEq~pDXg-xu0ytSMQfeAmnFmDjFO0YV76dTiGXic4CZvStzsL5IJwAHrTrx2sZuwC4Fmc5sLDrOjqIDgxWQvZH8cMcS0clGnwqZme31xCJPNCbwPJ68ZTSO-S91PguzCTLSl5EcR4JeLJZ8s9wCu43sbuw5NO0TKGa1i-P5rhxlkff2c2x7KHn-cuQB2hJdsaMudY~BRqQQ-p0O~0Qu9uoZSLrte7-46SP8C19OEJB92k1wbzXXLZCbVGw71Yp8yJUmJm2eR4JdWy2gK4dRGfa0rbOLNaz1OdTQ__" />
            <img src="https://s3-alpha-sig.figma.com/img/1018/3cf3/e5d5a8d65f9219625d2c3aedd3687fa0?Expires=1743984000&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=dVUyxRPVLev6JX6SIzNFPUoFMIQkxrNGMLSvj-SrR29JYx0vm8t174lIrWpUcN0emTlfXJCWv0HGTqF3WTFXBfSRkBFWEn9AvR0aT6y9KeH-2uYuTloTu9FpBLlk9CH1iXFBU9jAngPXSCdcLjEFeyPkDJpV1mM3AZu2avp2AQ27590MOhvBLyAp9cGw30Cm~FvArvjYOtw5O9w9LXaVHoA2X5xUChOKjTFHSCnhfLxYxQ7ifTw56KOPYbYtrF1lPMsnhAXVJ6Hr5ZC5tE~O8UuFXYfLxuGohOwBPaiKz9tMFfe-IV4KL9ipwheoiW0DGz9cjVLl00rn1Pp4ZOrLOw__" />
          </div>
        </div>
      </div>

      <div styleName="kayntiosoite">
        <div>
          <h2 styleName="header-two">Aluetoimistot</h2>
          <div styleName="contact-top">
            <div>
              <h2 styleName="header-two-subhead">
                {" "}
                <i class="ri-arrow-right-circle-line"></i> Radio Dei Pohjanmaa
              </h2>
            </div>
            <div>
              <p styleName="emails-para">
                Seuralantie 5 / huone 310 <br />
                60220 SEINÄJOKI <br />
                044 477 7888 <br />
                <a href="mailto:etunimi.sukunimi@radiodei.fi">toimitus.pohjanmaa@radiodei.fi</a>
              </p>
              <p styleName="emails-para"></p>
            </div>
          </div>
        </div>
      </div>

      <div styleName="kayntiosoite">
        <div>
          <h2 styleName="header-two">Laskustustiedot</h2>
          <div styleName="contact-top">
            <div>
              <h2 styleName="header-two-subhead">
                {" "}
                <i class="ri-arrow-right-circle-line"></i> Kristillinen Media Oy (Apix skannauspalvelu)
              </h2>
            </div>
            <div>
              <p styleName="emails-para">
                Y-tunnus: 1058141-9 <br />
                PL 16112 <br />
                00021 LASKUTUS <br />
              </p>
              <p styleName="emails-para">
                Operaattori: Apix Messaging Oy (003723327487) <br />
                Verkkolaskuosoite: 003710581419 <br />
                OVT-tunnus: 003710581419
              </p>
              <h2 styleName="header-two-subhead">Erityishuomio seuraaville operaattoreille</h2>
              <p>Danske Bank Oyj, Handelsbanken, Paikallisosuuspankit ja Säästöpankit:</p>
              <div styleName="list-styles">
                <ul>
                  <li>Verkkolaskuosoite: 003723327487</li>
                  <li>Operaattoritunnus: DABAFIHH</li>
                </ul>
              </div>
            </div>
            <p styleName="emails-para">
              Sähköpostiskannaus: <a href="mailto:003710581419@procountor.apix.fi">003710581419@procountor.apix.fi</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export { AsiakasPalvelu };
